import { render, staticRenderFns } from "./AddressSelected.vue?vue&type=template&id=0a09ef06&scoped=true"
import script from "./AddressSelected.vue?vue&type=script&lang=js"
export * from "./AddressSelected.vue?vue&type=script&lang=js"
import style0 from "./AddressSelected.vue?vue&type=style&index=0&id=0a09ef06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a09ef06",
  null
  
)

export default component.exports